import { Component, Input, OnInit } from '@angular/core';
import { Zona } from '../../../../_models/zona';
import { ZonaService } from '../../../../_services/zona.service';
import { forkJoin } from 'rxjs';
import { GrupoZonaService } from '../../../../_services/grupo-zona.service';
import { GrupoZona } from '../../../../_models/grupo-zona';
import { ConfirmationService } from 'primeng/api';
import { NavService } from '../../../../_services/_nav.service';
import { Location } from '@angular/common';
import { Grupo } from '../../../../_models/grupo';

@Component( {
  selector: 'app-grupo-zona',
  templateUrl: 'grupo-zona.component.html'
} )

export class GrupoZonaComponent implements OnInit {

  @Input() grupo: Grupo;
  lisZonaGrupo: GrupoZona[] = [];
  lisZonaLibre: GrupoZona[] = [];
  carInformacionInicial = true;
  lisGrupoZona: GrupoZona[] = [];
  guardando = false;
  // lisZonaGrupoTemp: GrupoZona[] = [];
  // lisZonaLibreTemp: GrupoZona[] = [];

  constructor( private zonServicio: ZonaService,
               private conServicio: ConfirmationService,
               private navServicio: NavService,
               private location: Location,
               private gruZonaServicio: GrupoZonaService ) {
  }

  ngOnInit(): void {
    forkJoin( this.zonServicio.getAllByEstructuraFisica( this.grupo.idEstructuraFisica ),
      this.gruZonaServicio.listado() ).subscribe( ( [ lisZonas, lisGrupoZona ] ) => {
      this.cargarZonas( lisZonas, lisGrupoZona );
      this.carInformacionInicial = false;
    } );
  }

  cargarZonas( lisZonas: Zona[], lisGrupoZona: GrupoZona[] ) {
    lisZonas.map( ( s: Zona ) => {
      if ( s.indicadorHabilitado ) {
        const a = lisGrupoZona.find( x => x.idZona === s.idZona );
        if ( a && a.indicadorHabilitado && a.idGrupo === this.grupo.idGrupo ) {
          this.lisZonaGrupo.push( a );
          this.lisGrupoZona.push( a );
        } else if ( a && !a.indicadorHabilitado && a.idGrupo === this.grupo.idGrupo ) {
          this.lisZonaLibre.push( a );
          this.lisGrupoZona.push( a );
        } else if ( a && !a.indicadorHabilitado ) {
          a.nombreZona = s.nombre;
          a.codigoZona = s.codigo;
          a.idGrupo = this.grupo.idGrupo;
          this.lisZonaLibre.push( a );
          this.lisGrupoZona.push( a );
        } else if ( !a ) {
          const nueRegistro = {} as GrupoZona;
          nueRegistro.idZona = s.idZona;
          nueRegistro.nombreZona = s.nombre;
          nueRegistro.codigoZona = s.codigo;
          nueRegistro.idGrupo = this.grupo.idGrupo;
          nueRegistro.indicadorHabilitado = true;
          this.lisZonaLibre.push( nueRegistro );
        }
      }
    } );
    // this.copiarTemporal();
  }

  /*copiarTemporal() {
    this.lisZonaGrupoTemp = [ ...this.lisZonaGrupo ];
    this.lisZonaLibreTemp = [ ...this.lisZonaLibre ];
  }*/

  onSubmit() {
    this.guardando = true;
    const registros = [];
    this.lisZonaGrupo.map( ( s: GrupoZona ) => {
      if ( !s.indicadorHabilitado ) {
        s.indicadorHabilitado = true;
        registros.push( s );
      } else if ( !!!s.idGrupoZona && s.indicadorHabilitado ) {
        registros.push( s );
        this.lisGrupoZona.push( s );
      }
    } );
    this.lisZonaLibre.map( ( s: GrupoZona ) => {
      if ( !!s.idGrupoZona && s.indicadorHabilitado ) {
        s.indicadorHabilitado = false;
        registros.push( s );
      }
    } );

    if ( registros.length > 0 ) {
      this.gruZonaServicio.bulk( registros ).subscribe( regActualizado => {
        regActualizado.map( ( s: GrupoZona ) => {
          const l = this.lisGrupoZona.find( x => x.idZona == s.idZona );
          if ( l && !!!l.idGrupoZona ) {
            l.idGrupoZona = s.idGrupoZona;
          }
        } );
        // this.copiarTemporal();
        this.navServicio.setMesage( 2 );
        this.guardando = false;
      }, error => {
        this.navServicio.setMesage( 3 );
        this.location.back();
      } );
    } else {
      // this.copiarTemporal();
      this.navServicio.setMesage( 2 );
      this.guardando = false;
    }
  }

  regresar() {
    this.conServicio.confirm( {
      message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
      header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: 'grupoZona',
      accept: () => {
        // this.lisZonaGrupo = [ ...this.lisZonaGrupoTemp ];
        // this.lisZonaLibre = [ ...this.lisZonaLibreTemp ];
        this.location.back();
      },
      reject: () => {
      }
    } );
  }

}
